export default function HealthClass() {
    let options = [
      { label: "Excellent Health", value: "PP" },
      { label: "Good Health", value: "P" },
      { label: "Some Health Issues", value: "R" },
    ];
    return options;
  }
  


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/HealthClass.js